module.exports = __webpack_public_path__ + "media/assets/images/landing/пенсия-1ec263d3d26d813370a0ce6bf9989337.png";